import React, { useState, useEffect } from "react";
import { useJwt } from "react-jwt";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../Redux/Reducers/authSlice";

const IsLoggedinHOC = (WrappedComponent) => {
  const HocComponent = ({ ...props }) => {
    const dispatch = useDispatch();
    const { accessToken } = useSelector((state) => state.auth);
    const { isExpired } = useJwt(accessToken);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
      if (isExpired) {
        setShowModal(true);
      }
    }, [isExpired]);

    const handleLogout = () => {
      dispatch(logout());
      setShowModal(false);
    };

    console.log("isExpiredisExpired",isExpired)

    return (
      <>
        {showModal && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
            <div className="bg-white p-8 rounded-xl shadow-2xl w-96 text-center border-t-4 border-red-500">
              <h2 className="text-2xl font-bold text-red-600">Session Expired</h2>
              <p className="text-gray-600 mt-4 text-lg">Your session got expired. Please log in again to continue.</p>
              <button
                onClick={handleLogout}
                className="mt-6 px-6 py-3 bg-black text-white rounded-lg text-lg font-semibold hover:bg-white hover:text-black border border-black transition-all"
              >
                Login Again
              </button>
            </div>
          </div>
        )}
        {!isExpired && <WrappedComponent {...props} isTokenExpired={isExpired} />}
      </>
    );
  };

  return HocComponent;
};

export default IsLoggedinHOC;